import { Slider } from '../../../../components/Slider/Slider';
import React from 'react';
import { useSelector } from 'react-redux';
import { getIsLocationPlatformMobileSelector } from '../../../Location/locationSelectors';
import { useLangContext } from '../../../../providers/LangProvider/LangProviderContext';
import { UserStatusStandardLotInfoDescriptionStyled } from './styled/UserStatusStandardLotInfoStyled';
import { Modal } from 'react-bootstrap';

interface IUserStatusStandardLotInfoProps {
    onClose: () => void,
    show: boolean,
}

function UserStatusStandardLotInfo(props: IUserStatusStandardLotInfoProps) {
    const { onClose, show } = props;
    const { getLangPath } = useLangContext();

    const isMobilePlatform = useSelector(getIsLocationPlatformMobileSelector);

    const title = getLangPath('user_statuses.standard_lot.title');
    const description = getLangPath('user_statuses.standard_lot.description');

    return isMobilePlatform
        ? <Slider
            onClose={onClose}
            placement={'bottom'}
            show={show}
            showCloseButton={false}
            swipeDownToClose
        >
            <div className={'d-flex flex-column'}>
                <h6>{title}</h6>
                <UserStatusStandardLotInfoDescriptionStyled
                    className={'mt-3'}
                    dangerouslySetInnerHTML={{ __html: description }}
                />
            </div>
        </Slider>
        : <Modal
            onHide={onClose}
            show={show}
            centered
        >
            <Modal.Header closeButton>{title}</Modal.Header>
            <Modal.Body className={'px-4 pb-4'}>
                <UserStatusStandardLotInfoDescriptionStyled
                    dangerouslySetInnerHTML={{ __html: description }}
                />
            </Modal.Body>
        </Modal>;
}

export default UserStatusStandardLotInfo;
